import { render, staticRenderFns } from "./FontChooser.vue?vue&type=template&id=6158fcb4"
import script from "./FontChooser.vue?vue&type=script&lang=js"
export * from "./FontChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports